import { useEffect, useState } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useBuscarAssociacao = () => {
  const [Params, setParams] = useState({
    sqAcaoFiscal: null,
    sqPessoa: null,
  });
  const [AltAssociacao, setAltAssociacao] = useState();
  const { request: requestAssociacao, data: dataAssociacao } = useApiClient();

  useEffect(() => {
    if (Params?.sqPessoa) {
      const values = Params;
      requestAssociacao(apiRoutes.fiscalizacao.ordemservico.buscaaltrepresentantetsps, values);
    }
  }, [requestAssociacao, Params]);

  useEffect(() => {
    if (dataAssociacao?.result) {
      setAltAssociacao(dataAssociacao?.result);
    }
  }, [dataAssociacao]);

  return { AltAssociacao, setParams };
};

export default useBuscarAssociacao;
